<div class="profile-page-content">
    <!-- Header -->
    <img  *ngIf="user.user.theme.name==='custom'"
  [src]="user.user.theme.customTheme.backgroundImage"
  alt="Banner"
  style="width: 100%; aspect-ratio: 1200 / 250; padding: 20px;">

    <header class="page-header">
      <div class="header-content">
        <span class="square-dot"></span>
        <h1 class="page-title">My Profile</h1>
      </div>
    </header>
  
    <!-- Profile Content -->
    <div class="profile-content">
      <!-- User Profile Section -->
      <section class="user-profile-section">
        <div class="profile-avatar">
          <div class="large-avatar">
            {{ user?.user?.name ? user.user.name.charAt(0) : '-' }}
          </div>
        </div>
        <div class="profile-details">
          <h2 class="user-name">{{ user?.user?.name ? user.user.name : '-' }}</h2>
          <p class="user-grade">{{ user.user.studentClass.grade ? user.user.studentClass.grade : '-' }}</p>
        </div>
      </section>
    
      <!-- Basic Info Section -->
      <section class="basic-info-section">
        <h3 class="section-heading">Basic Info</h3>
    
        <div class="info-grid">
          <div class="info-row">
            <div class="info-field">
              <label class="field-label">Full Name</label>
              <p class="field-value">{{ user?.user?.name ? user.user.name : '-' }}</p>
            </div>
            <div class="info-field">
              <label class="field-label">Grade</label>
              <p class="field-value">
                {{ user?.user?.studentClass?.grade ? user.user.studentClass.grade : '-' }} 
                '{{ user?.user?.studentClass?.section ? user.user.studentClass.section : '-' }}' section
              </p>
            </div>
          </div>
    
          <div class="info-row">
            <div class="info-field">
              <label class="field-label">School Name</label>
              <p class="field-value">{{ user?.user?.schoolName ? user.user.schoolName : '-' }}</p>
            </div>
            <div class="info-field">
              <label class="field-label">Tutor</label>
              <p class="field-value">{{ user?.user?.classTutor ? user.user.classTutor : '-' }}</p>
            </div>
          </div>
    
          <div class="info-row single-column">
            <div class="info-field">
              <label class="field-label">Email Address</label>
              <p class="field-value">{{ user?.user?.email ? user.user.email : '-' }}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
    
  
    <!-- Basketball Character -->
    <!-- <div class="character-container">
      <img src="assets/images/basketball-character.png" alt="Basketball Character" class="basketball-character">
    </div> -->
  </div>
  